export const partners = new Map([
  [
    0,
    {
      name: 'TechSuite POS',
      icon: 'techsuite-logo',
      logo: 'techsuite.svg',
      color: '#101f3b',
    },
  ],
  [
    1,
    {
      name: 'Embargo',
      icon: 'embargo-logo',
      logo: 'embargo-big.png',
      color: '#FF4A60',
    },
  ],
  [
    2,
    {
      name: 'Square',
      icon: 'square-logo',
      logo: 'square-big.png',
      color: '#2a2627',
    },
  ],
  [
    3,
    {
      name: 'Wolt',
      icon: 'wolt-logo',
      logo: 'wolt.svg',
      color: '#00C2E8',
    },
  ],
  [
    4,
    {
      name: 'Epos Now',
      icon: 'eposnow-logo',
      logo: 'epos-now-big.png',
      color: '#00b5fa',
    },
  ],
  [
    5,
    {
      name: 'Uber Eats',
      icon: 'uber-eats-logo',
      logo: 'uber-big.png',
      color: '#06c167',
    },
  ],
  [
    6,
    {
      name: 'Deliveroo',
      icon: 'deliveroo-logo',
      logo: 'deliveroo-big.png',
      color: '#00ccbc',
    },
  ],
  [
    7,
    {
      name: 'GoodTill',
      icon: 'goodtill-logo',
      logo: 'GoodTill.svg',
      color: '#00dab4',
    },
  ],
  [
    8,
    {
      name: 'Bolt',
      icon: 'bolt-logo',
      logo: 'bolt-big.png',
      color: '#2ed78b',
    },
  ],
  [
    9,
    {
      name: 'Slack',
      icon: 'slack-logo',
      logo: 'slack-big.png',
      color: '#000000',
    },
  ],
  [
    10,
    {
      name: 'Lightspeed',
      icon: 'lightspeed-logo',
      logo: 'light-speed-big',
      color: '#e81c1c',
    },
  ],
  [
    11,
    {
      name: 'Glovo',
      icon: 'glovo-logo',
      logo: 'glovo-big.png',
      color: '#3d9f83',
    },
  ],
  [
    12,
    {
      name: 'Dotypos',
      icon: 'dotypos-logo',
      logo: 'dotypos.png',
      color: '#2fa836',
    },
  ],
  [
    13,
    {
      name: 'WorldPay',
      icon: 'worldpay-logo',
      logo: 'worldpay.png',
      color: '#ff1f3f',
    },
  ],
  [
    14,
    {
      name: 'Zettle',
      icon: '',
      logo: '',
      color: '',
    },
  ],
  [
    15,
    {
      name: 'SumUp',
      icon: '',
      logo: '',
      color: '',
    },
  ],
  [
    16,
    {
      name: 'Xero',
      icon: 'xero-logo',
      logo: 'xero-big.png',
      color: '#00b2d5',
    },
  ],
  [
    17,
    {
      name: 'Fourth',
      icon: 'fourth-logo',
      logo: 'fourth-big.png',
      color: '#173463',
    },
  ],
  [
    18,
    {
      name: 'Wealthon',
      icon: 'wealthon-logo',
      logo: 'wealthon-big.png',
      color: '#010080',
    },
  ],
  [
    19,
    {
      name: 'TechSuite Kiosk',
      icon: 'techsuite-kiosk',
      logo: '',
      color: '#101f3b',
    },
  ],
  [
    20,
    {
      name: 'Square Payment',
      icon: 'square-logo',
      logo: 'square-big.png',
      color: '#2a2627',
    },
  ],
  [
    21,
    {
      name: 'EmbargoPay',
      icon: 'embargo-pay-logo',
      logo: 'embargo-pay.png',
      color: '#ff4a60',
    },
  ],
  [
    22,
    {
      name: 'JustEat',
      icon: 'just-eat-logo',
      logo: 'just-eat-small.png',
      color: '#ff8000',
    },
  ],
])
